import React, { useContext } from "react";
import styled from "styled-components";
import { EventContext } from "Components";
import ReactHtmlParser from "react-html-parser";
import { useParams } from "react-router-dom";

export const Rules = () => {
  const { event } = useContext(EventContext);
  const { market } = useParams();

  let validMarket = false;
  if (market) validMarket = event.rules.markets[market];

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  const storageDirectory = event.storageDirectory;

  let rulesDoc = `${api}/o/${storageDirectory}%2F${validMarket.pdf}?alt=media`;

  return (
    <RulesWrapper>
      <Main as="main">
        <RulesHeading>{ReactHtmlParser(event?.rules?.body)}</RulesHeading>

        {validMarket && (
          <>
            <h3>{ReactHtmlParser(validMarket.heading)}</h3>
            <RulesFrame src={rulesDoc} />
          </>
        )}
      </Main>
    </RulesWrapper>
  );
};

const RulesWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
`;

const Main = styled.main`
  padding: 15px;

  a {
    color: #000000;
  }

  a:hover {
    color: #951c2f;
  }

  .menu {
    display: flex;
    padding: 0;
    list-style: none;

    li {
      margin-right: 10px;
    }
  }
`;

const RulesHeading = styled.div`
  & > p {
    margin-top: 0;
  }
`;

const RulesFrame = styled.iframe`
  border: 0;
  width: 100%;
  height: 100vh;
`;
